import _ from 'lodash'
import { type InstacartCustomersSharedV1Locale } from 'domains/retailer-collections/api'
import { type RetailerCollectionFormTranslation } from 'domains/retailer-collections/components/form/utils/types'
import { type WarehouseWithLocations } from 'utils/contexts/warehouse/queries/warehouse'

export const addTranslationShims = (
  locales: WarehouseWithLocations['locales'],
  translations: RetailerCollectionFormTranslation[]
) => {
  const initialTranslations = translations ?? []
  const existingLocales = initialTranslations.map(({ localeCode }) => localeCode)
  const allSupportedLocales = locales.map(
    ({ localeCode }) => localeCode.toUpperCase() as InstacartCustomersSharedV1Locale
  )

  // With the remainder of the locales, create a shim for each
  const remainingLocales = _.without(allSupportedLocales, ...existingLocales).map(localeCode => ({
    localeCode,
    name: '',
  }))

  return initialTranslations.concat(remainingLocales)
}
